import { MenuList } from "@mui/material";
import { observer } from "mobx-react";
import * as React from "react";
import app from "../../../application/App";
import MenuItemComponent from "./menu/MenuItemComponent";

interface IProps {}

const TopMenuComponent: React.FC<IProps> = (props) => {
  const appStore = React.useMemo(() => app(), []);

  if (!appStore.menu || appStore.menu.items.length < 1) return <div />;

  const hasIcon = appStore.menu.items?.filter((x) => x.icon != null).length > 0;

  return (
    <MenuList>
      {appStore.menu.items.map((item, i) => (
        <MenuItemComponent
          key={`${i}-${item.label}`}
          item={item}
          showIcon={hasIcon}
        />
      ))}
    </MenuList>
  );
};

export default observer(TopMenuComponent);
